export enum LiveGridColumnId {
  // Negotiation fields
  NEGOTIATION_ID = 'NEGOTIATION_ID',
  NEGOTIATION_AXE_ID = 'NEGOTIATION_AXE_ID',
  NEGOTIATION_DIRECTION = 'NEGOTIATION_DIRECTION',
  NEGOTIATION_STATUS = 'NEGOTIATION_STATUS',
  NEGOTIATION_FACTOR = 'NEGOTIATION_FACTOR',
  NEGOTIATION_ASSET_TYPE = 'NEGOTIATION_ASSET_TYPE',
  NEGOTIATION_NOTIONAL = 'NEGOTIATION_NOTIONAL',
  NEGOTIATION_MULTIPLE_NOTIONAL = 'NEGOTIATION_MULTIPLE_NOTIONAL',
  NEGOTIATION_NOTIONAL_ORIGINAL = 'NEGOTIATION_NOTIONAL_ORIGINAL',
  NEGOTIATION_RATE = 'NEGOTIATION_RATE',
  NEGOTIATION_RATE_TARGET = 'NEGOTIATION_RATE_TARGET',
  NEGOTIATION_FEE = 'NEGOTIATION_FEE',
  NEGOTIATION_TERM = 'NEGOTIATION_TERM',
  NEGOTIATION_TERM_TARGET = 'NEGOTIATION_TERM_TARGET',
  NEGOTIATION_START_DATE = 'NEGOTIATION_START_DATE',
  NEGOTIATION_START_DATE_TARGET = 'NEGOTIATION_START_DATE_TARGET',
  NEGOTIATION_END_DATE = 'NEGOTIATION_END_DATE',
  NEGOTIATION_END_DATE_TARGET = 'NEGOTIATION_END_DATE_TARGET',
  NEGOTIATION_HAIRCUT_TYPE = 'NEGOTIATION_HAIRCUT_TYPE',
  NEGOTIATION_HAIRCUT = 'NEGOTIATION_HAIRCUT',
  NEGOTIATION_HAIRCUT_TARGET = 'NEGOTIATION_HAIRCUT_TARGET',
  NEGOTIATION_SETTLEMENT_VENUE = 'NEGOTIATION_SETTLEMENT_VENUE',
  NEGOTIATION_CSD = 'NEGOTIATION_CSD',
  NEGOTIATION_CALLABLE = 'NEGOTIATION_CALLABLE',
  NEGOTIATION_CALL_DAYS = 'NEGOTIATION_CALL_DAYS',
  NEGOTIATION_AXE_ROLL_UNWIND = 'NEGOTIATION_AXE_ROLL_UNWIND',
  NEGOTIATION_BOND_PRICE = 'NEGOTIATION_BOND_PRICE',
  NEGOTIATION_ALL_IN_PRICE = 'NEGOTIATION_AIP',
  NEGOTIATION_REPO_TYPE = 'NEGOTIATION_REPO_TYPE',
  NEGOTIATION_ACCRUED_INTEREST = 'NEGOTIATION_ACCRUED_INTEREST',
  NEGOTIATION_REPO_INTEREST = 'NEGOTIATION_REPO_INTEREST',
  NEGOTIATION_START_CONSIDERATION = 'NEGOTIATION_START_CONSIDERATION',
  NEGOTIATION_START_CONSIDERATION_OVERRIDE = 'START_CONSIDERATION_OVERRIDE',
  NEGOTIATION_ABSOLUTE_CONSIDERATION = 'NEGOTIATION_ABSOLUTE_CONSIDERATION',
  NEGOTIATION_START_CONSIDERATION_ORIGINAL = 'NEGOTIATION_START_CONSIDERATION_ORIGINAL',
  NEGOTIATION_END_CONSIDERATION = 'NEGOTIATION_END_CONSIDERATION',
  NEGOTIATION_LAST_QUOTED = 'NEGOTIATION_LAST_QUOTED',
  NEGOTIATION_MARKET = 'NEGOTIATION_MARKET',
  NEGOTIATION_ORDER_ID = 'NEGOTIATION_ORDER_ID',
  NEGOTIATION_LAST_INITIATOR = 'NEGOTIATION_LAST_INITIATOR',
  NEGOTIATION_LAST_RESPONDER = 'NEGOTIATION_LAST_RESPONDER',
  NEGOTIATION_CREATED_AT_DATE = 'NEGOTIATION_CREATED_AT_DATE',
  NEGOTIATION_CREATED_AT_TIME = 'NEGOTIATION_CREATED_AT_TIME',
  NEGOTIATION_UPDATED_BY = 'NEGOTIATION_UPDATED_BY',
  NEGOTIATION_UPDATED_AT_DATE = 'NEGOTIATION_UPDATED_AT_DATE',
  NEGOTIATION_UPDATED_AT_TIME = 'NEGOTIATION_UPDATED_AT_TIME',
  NEGOTIATION_COMPETITION_COUNT = 'COMPETITION_COUNT',
  NEGOTIATION_TRADE_TYPE = 'NEGOTIATION_TRADE_TYPE',
  INVESTMENT_DECISION_MAKER = 'INVESTMENT_DECISION_MAKER',
  EXECUTION_DECISION_MAKER = 'EXECUTION_DECISION_MAKER',
  NEGOTIATION_NOTICE_PERIOD_DAYS = 'NEGOTIATION_NOTICE_PERIOD_DAYS',
  NEGOTIATION_RFQ_TYPE = 'NEGOTIATION_RFQ_TYPE',
  NEGOTIATION_TOTAL_FILL_NOTIONAL = 'NEGOTIATION_TOTAL_FILL_NOTIONAL',
  NEGOTIATION_TARGET_FILL_NOTIONAL = 'NEGOTIATION_TARGET_FILL_NOTIONAL',
  NEGOTIATION_TOTAL_FILL_START_CONSIDERATION = 'NEGOTIATION_TOTAL_FILL_START_CONSIDERATION',
  NEGOTIATION_TARGET_FILL_START_CONSIDERATION = 'NEGOTIATION_TARGET_FILL_START_CONSIDERATION',
  NEGOTIATION_PRE_AGREED = 'NEGOTIATION_PRE_AGREED',
  NEGOTIATION_MASTER_LEGAL_AGREEMENT = 'NEGOTIATION_MASTER_LEGAL_AGREEMENT',
  NEGOTIATION_PRIMARY_SALES_COVER = 'NEGOTIATION_PRIMARY_SALES_COVER',
  NEGOTIATION_SECONDARY_SALES_COVER = 'NEGOTIATION_SECONDARY_SALES_COVER',
  NEGOTIATION_RESPONDER_BOOK = 'NEGOTIATION_RESPONDER_BOOK',
  NEGOTIATION_RESPONDER_STRATEGY = 'NEGOTIATION_RESPONDER_STRATEGY',
  NEGOTIATION_IS_CURVE = 'NEGOTIATION_IS_CURVE',
  NEGOTIATION_STOCK_BORROWING_LENDING_TYPE = 'NEGOTIATION_STOCK_BORROWING_LENDING_TYPE',
  EVERGREEN_NOTICE_PERIOD = 'EVERGREEN_NOTICE_PERIOD',
  LINKED_TRADE_ID = 'LINKED_TRADE_ID',
  MY_ENTITY_SHORT_NAME = 'MY_ENTITY_SHORT_NAME',
  MY_FICC_ENTITY_SHORT_NAME = 'MY_FICC_ENTITY_SHORT_NAME',
  BATCH_ID = 'BATCH_ID',
  ISSUE = 'ISSUE',
  MARKET_TRADE_DATE = 'MARKET_TRADE_DATE',
  SUBMITTING_USER = 'SUBMITTING_USER',
  // Collateral fields
  COLLATERAL_ISIN_OR_BUI = 'COLLATERAL_ISIN_OR_BUI',
  COLLATERAL_CURRENCY = 'COLLATERAL_CURRENCY',
  COLLATERAL_NAME = 'COLLATERAL_NAME',
  COLLATERAL_CUSIP = 'COLLATERAL_CUSIP',
  COLLATERAL_COUPON = 'COLLATERAL_COUPON',
  COLLATERAL_ISSUER = 'COLLATERAL_ISSUER',
  SECONDARY_COLLATERAL_NAME = 'SECONDARY_COLLATERAL_NAME',

  //SBL Fields
  STOCK_BORROW_LENDING_TYPE = 'STOCK_BORROW_LENDING_TYPE',

  // Product fields
  PRODUCT = 'PRODUCT',
  PRODUCT_SECTOR = 'PRODUCT_SECTOR',

  BOOK_NAME = 'BOOK_NAME',
  REFERENCE_RATE_NAME = 'REFERENCE_RATE_NAME',
  FLOAT_CRYSTALLISATION_DAYS = 'FLOAT_CRYSTALLISATION_DAYS',
  STRATEGY_NAME = 'STRATEGY_NAME',
  PRIME_BROKER_NAME = 'PRIME_BROKER_NAME',
  BUNDLE_NAME = 'BUNDLE_NAME',

  // Trading Entity fields
  BLOCK_TRADE = 'BLOCK_TRADE',
  FUND_NAME = 'FUND_NAME',
  FUND_LEI = 'FUND_LEI',
  FUND_BIC = 'FUND_BIC',
  FUND_FIRM = 'FUND_FIRM',
  FUND_FIRM_LEI = 'FUND_FIRM_LEI',
  COUNTERPARTY_NAME = 'COUNTERPARTY_NAME',
  COUNTERPARTY_LEI = 'COUNTERPARTY_LEI',
  COUNTERPARTY_BIC = 'COUNTERPARTY_BIC',
  COUNTERPARTY_FIRM = 'COUNTERPARTY_FIRM',
  COUNTERPARTY_FIRM_LEI = 'COUNTERPARTY_FIRM_LEI',

  // Delta Fields
  NOTIONAL_DELTA = 'NOTIONAL_DELTA',
  START_CONSIDERATION_DELTA = 'START_CONSIDERATION_DELTA',
  RATE_DELTA = 'RATE_DELTA',
  HAIRCUT_DELTA = 'HAIRCUT_DELTA',
  START_DATE_DELTA = 'START_DATE_DELTA',
  END_DATE_DELTA = 'END_DATE_DELTA',

  OTW_DURATION = 'OTW_DURATION',
  RFQ_TIMER = 'RFQ_TIMER',
  OTW_TIMER_SELECTED_COUNTERPARTY = 'OTW_TIMER_SELECTED_COUNTERPARTY',
  RFQ_OTW_DURATION_ACTION = 'RFQ_OTW_DURATION_ACTION',
  COUNTERPARTY_AXE_ROLL_UNWIND_SUMMARY = 'COUNTERPARTY_AXE_ROLL_UNWIND_SUMMARY',
  NOTES = 'NOTES',
  UPLOAD_ROW_INDEX = 'UPLOAD_ROW_INDEX',
  ALLOW_PARTIAL = 'ALLOW_PARTIAL',

  // Derived Data Fields
  BEST_COUNTERPARTY = 'BEST_COUNTERPARTY',
  BEST_NEGOTIATION_RATE = 'BEST_NEGOTIATION_RATE',
  BEST_HAIRCUT = 'BEST_HAIRCUT',
  BEST_NEGOTIATION_REPO_INTEREST = 'BEST_NEGOTIATION_REPO_INTEREST',
  COUNTERPARTY_RESPONSE_COUNT = 'COUNTERPARTY_RESPONSE_COUNT'
}

export const deltaColumnIds = [
  LiveGridColumnId.NOTIONAL_DELTA,
  LiveGridColumnId.RATE_DELTA,
  LiveGridColumnId.HAIRCUT_DELTA,
  LiveGridColumnId.START_DATE_DELTA,
  LiveGridColumnId.END_DATE_DELTA,
  LiveGridColumnId.START_CONSIDERATION_DELTA
]

export const NegotiationFieldNames = {
  // Negotiation fields
  STATUS: 'negotiation.status',
  NOTIONAL: 'negotiation.notional',
  NOTIONAL_NEGOTIATED: 'negotiation.notional.negotiated',
  NOTIONAL_MODIFIED: 'negotiation.notional.modifiedValue',
  NOTIONAL_IS_MODIFIED: 'negotiation.notional.modified',
  RATE: 'negotiation.rate',
  RATE_NEGOTIATED: 'negotiation.rate.negotiated',
  RATE_MODIFIED: 'negotiation.rate.modifiedValue',
  RATE_IS_MODIFIED: 'negotiation.rate.modified',
  FEE: 'negotiation.fee',
  FEE_NEGOTIATED: 'negotiation.fee.negotiated',
  FEE_MODIFIED: 'negotiation.fee.modifiedValue',
  FEE_IS_MODIFIED: 'negotiation.fee.modified',
  TERM: 'negotiation.term',
  TERM_NEGOTIATED: 'negotiation.term.negotiated',
  TERM_MODIFIED: 'negotiation.term.modifiedValue',
  TERM_IS_MODIFIED: 'negotiation.term.modified',
  START_DATE: 'negotiation.startDate',
  START_DATE_NEGOTIATED: 'negotiation.startDate.negotiated',
  START_DATE_MODIFIED: 'negotiation.startDate.modifiedValue',
  START_DATE_IS_MODIFIED: 'negotiation.startDate.modified',
  END_DATE: 'negotiation.endDate',
  END_DATE_NEGOTIATED: 'negotiation.endDate.negotiated',
  END_DATE_MODIFIED: 'negotiation.endDate.modifiedValue',
  END_DATE_IS_MODIFIED: 'negotiation.endDate.modified',

  HAIRCUT_TYPE: 'negotiation.haircutType',
  HAIRCUT_TYPE_NEGOTIATED: 'negotiation.haircutType.negotiated',
  HAIRCUT_TYPE_MODIFIED: 'negotiation.haircutType.modifiedValue',
  HAIRCUT_TYPE_IS_MODIFIED: 'negotiation.haircutType.modified',

  HAIRCUT: 'negotiation.haircut',
  HAIRCUT_NEGOTIATED: 'negotiation.haircut.negotiated',
  HAIRCUT_MODIFIED: 'negotiation.haircut.modifiedValue',
  HAIRCUT_IS_MODIFIED: 'negotiation.haircut.modified',
  AXE: 'negotiation.isAxed.modifiedValue',
  ROLL_UNWIND: 'negotiation.tradeConditionFlag.modifiedValue',
  BOND_PRICE: 'negotiation.bondPrice',
  BOND_PRICE_NEGOTIATED: 'negotiation.bondPrice.negotiated',
  BOND_PRICE_MODIFIED: 'negotiation.bondPrice.modifiedValue',
  BOND_PRICE_IS_MODIFIED: 'negotiation.bondPrice.modified',
  START_CONSIDERATION: 'negotiation.startConsideration',
  START_CONSIDERATION_NEGOTIATED: 'negotiation.startConsideration.negotiated',
  START_CONSIDERATION_MODIFIED: 'negotiation.startConsideration.modifiedValue',
  START_CONSIDERATION_IS_MODIFIED: 'negotiation.startConsideration.modified',

  START_CONSIDERATION_OVERRIDE: 'negotiation.startConsiderationOverride',
  START_CONSIDERATION_OVERRIDE_NEGOTIATED: 'negotiation.startConsiderationOverride.negotiated',
  START_CONSIDERATION_OVERRIDE_MODIFIED: 'negotiation.startConsiderationOverride.modifiedValue',
  START_CONSIDERATION_OVERRIDE_IS_MODIFIED: 'negotiation.startConsiderationOverride.modified',

  RFQ_TYPE: 'negotiation.rfqType',
  RFQ_TYPE_NEGOTIATED: 'negotiation.rfqType.negotiated',
  RFQ_TYPE_MODIFIED: 'negotiation.rfqType.modifiedValue',
  RFQ_TYPE_IS_MODIFIED: 'negotiation.rfqType.modified',

  COUNTERPARTY_SPONSOR_ID: 'negotiation.counterpartySponsorId',
  COUNTERPARTY_SPONSOR_ID_NEGOTIATED: 'negotiation.counterpartySponsorId.negotiated',
  COUNTERPARTY_SPONSOR_ID_MODIFIED: 'negotiation.counterpartySponsorId.modifiedValue',
  COUNTERPARTY_SPONSOR_ID_IS_MODIFIED: 'negotiation.counterpartySponsorId.modified',

  INITIATOR_INVESTMENT_DECISION_MAKER: 'negotiation.initiatorInvestmentDecisionMaker',
  INITIATOR_INVESTMENT_DECISION_MAKER_NEGOTIATED: 'negotiation.initiatorInvestmentDecisionMaker.negotiated',
  INITIATOR_INVESTMENT_DECISION_MAKER_MODIFIED: 'negotiation.initiatorInvestmentDecisionMaker.modifiedValue',
  INITIATOR_INVESTMENT_DECISION_MAKER_IS_MODIFIED: 'negotiation.initiatorInvestmentDecisionMaker.modified',

  INITIATOR_EXECUTION_DECISION_MAKER: 'negotiation.initiatorExecutionDecisionMaker',
  INITIATOR_EXECUTION_DECISION_MAKER_NEGOTIATED: 'negotiation.initiatorExecutionDecisionMaker.negotiated',
  INITIATOR_EXECUTION_DECISION_MAKER_MODIFIED: 'negotiation.initiatorExecutionDecisionMaker.modifiedValue',
  INITIATOR_EXECUTION_DECISION_MAKER_IS_MODIFIED: 'negotiation.initiatorExecutionDecisionMaker.modified',

  RESPONDER_INVESTMENT_DECISION_MAKER: 'negotiation.responderInvestmentDecisionMaker',
  RESPONDER_INVESTMENT_DECISION_MAKER_NEGOTIATED: 'negotiation.responderInvestmentDecisionMaker.negotiated',
  RESPONDER_INVESTMENT_DECISION_MAKER_MODIFIED: 'negotiation.responderInvestmentDecisionMaker.modifiedValue',
  RESPONDER_INVESTMENT_DECISION_MAKER_IS_MODIFIED: 'negotiation.responderInvestmentDecisionMaker.modified',

  RESPONDER_EXECUTION_DECISION_MAKER: 'negotiation.responderExecutionDecisionMaker',
  RESPONDER_EXECUTION_DECISION_MAKER_NEGOTIATED: 'negotiation.responderExecutionDecisionMaker.negotiated',
  RESPONDER_EXECUTION_DECISION_MAKER_MODIFIED: 'negotiation.responderExecutionDecisionMaker.modifiedValue',
  RESPONDER_EXECUTION_DECISION_MAKER_IS_MODIFIED: 'negotiation.responderExecutionDecisionMaker.modified',

  PRE_AGREED: 'negotiation.preAgreed',
  PRE_AGREED_NEGOTIATED: 'negotiation.preAgreed.negotiated',
  PRE_AGREED_MODIFIED: 'negotiation.preAgreed.modifiedValue',
  PRE_AGREED_IS_MODIFIED: 'negotiation.preAgreed.modified',

  COUNTERPARTY_NAME: 'negotiation.counterpartyIdNegotiableField',
  COUNTERPARTY_NAME_NEGOTIATED: 'negotiation.counterpartyIdNegotiableField.negotiated',
  COUNTERPARTY_NAME_MODIFIED: 'negotiation.counterpartyIdNegotiableField.modifiedValue',
  COUNTERPARTY_NAME_IS_MODIFIED: 'negotiation.counterpartyIdNegotiableField.modified',

  BOOK: 'negotiation.book',
  BOOK_NEGOTIATED: 'negotiation.book.negotiated',
  BOOK_MODIFIED: 'negotiation.book.modifiedValue',
  BOOK_IS_MODIFIED: 'negotiation.book.modified',

  STRATEGY: 'negotiation.strategy',
  STRATEGY_NEGOTIATED: 'negotiation.strategy.negotiated',
  STRATEGY_MODIFIED: 'negotiation.strategy.modifiedValue',
  STRATEGY_IS_MODIFIED: 'negotiation.strategy.modified',

  INITIATOR_BOOK: 'negotiation.initiatorBook',
  INITIATOR_BOOK_NEGOTIATED: 'negotiation.initiatorBook.negotiated',
  INITIATOR_BOOK_MODIFIED: 'negotiation.initiatorBook.modifiedValue',
  INITIATOR_BOOK_IS_MODIFIED: 'negotiation.initiatorBook.modified',

  INITIATOR_STRATEGY: 'negotiation.initiatorStrategy',
  INITIATOR_STRATEGY_NEGOTIATED: 'negotiation.initiatorStrategy.negotiated',
  INITIATOR_STRATEGY_MODIFIED: 'negotiation.initiatorStrategy.modifiedValue',
  INITIATOR_STRATEGY_IS_MODIFIED: 'negotiation.initiatorStrategy.modified',

  RESPONDER_BOOK: 'negotiation.responderBook',
  RESPONDER_BOOK_NEGOTIATED: 'negotiation.responderBook.negotiated',
  RESPONDER_BOOK_MODIFIED: 'negotiation.responderBook.modifiedValue',
  RESPONDER_BOOK_IS_MODIFIED: 'negotiation.responderBook.modified',

  RESPONDER_STRATEGY: 'negotiation.responderStrategy',
  RESPONDER_STRATEGY_NEGOTIATED: 'negotiation.responderStrategy.negotiated',
  RESPONDER_STRATEGY_MODIFIED: 'negotiation.responderStrategy.modifiedValue',
  RESPONDER_STRATEGY_IS_MODIFIED: 'negotiation.responderStrategy.modified',

  SECONDARY_COLLATERAL_ID: 'negotiation.secondaryCollateralId',
  SECONDARY_COLLATERAL_ID_NEGOTIATED: 'negotiation.secondaryCollateralId.negotiated',
  SECONDARY_COLLATERAL_ID_MODIFIED: 'negotiation.secondaryCollateralId.modifiedValue',
  SECONDARY_COLLATERAL_ID_IS_MODIFIED: 'negotiation.secondaryCollateralId.modified',

  SECONDARY_BASKET_ID: 'negotiation.secondaryBasketId',
  SECONDARY_BASKET_ID_NEGOTIATED: 'negotiation.secondaryBasketId.negotiated',
  SECONDARY_BASKET_ID_MODIFIED: 'negotiation.secondaryBasketId.modifiedValue',
  SECONDARY_BASKET_ID_IS_MODIFIED: 'negotiation.secondaryBasketId.modified',

  STOCK_BORROW_LENDING_TYPE: 'negotiation.stockBorrowingLendingType',
  STOCK_BORROW_LENDING_TYPE_NEGOTIATED: 'negotiation.stockBorrowingLendingType.negotiated',
  STOCK_BORROW_LENDING_TYPE_MODIFIED: 'negotiation.stockBorrowingLendingType.modifiedValue',
  STOCK_BORROW_LENDING_TYPE_IS_MODIFIED: 'negotiation.stockBorrowingLendingType.modified',

  SETTLEMENT_VENUE: 'negotiation.settlementVenueNegotiable',
  SETTLEMENT_VENUE_NEGOTIATED: 'negotiation.settlementVenueNegotiable.negotiated',
  SETTLEMENT_VENUE_MODIFIED: 'negotiation.settlementVenueNegotiable.modifiedValue',
  SETTLEMENT_VENUE_IS_MODIFIED: 'negotiation.settlementVenueNegotiable.modified',

  LINKED_TRADE_ID: 'negotiation.servicingTrigger',
  MY_ENTITY_SHORT_NAME: 'negotiation.orderFund.shortName',

  // Other columns
  OTW_DURATION: 'otwDuration'
}

// TODO - I think I can remove this now.
const notionalGroup = [LiveGridColumnId.NEGOTIATION_NOTIONAL_ORIGINAL]
const rateGroup = [LiveGridColumnId.NEGOTIATION_RATE_TARGET]
const haircutGroup = [LiveGridColumnId.NEGOTIATION_HAIRCUT_TARGET]
const startDateGroup = [LiveGridColumnId.NEGOTIATION_START_DATE_TARGET]
const endDateGroup = [LiveGridColumnId.NEGOTIATION_END_DATE_TARGET]
const startConsiderationGroup = [LiveGridColumnId.NEGOTIATION_START_CONSIDERATION_ORIGINAL]

export const columnsGroups: Record<string, string[]> = {
  [LiveGridColumnId.NEGOTIATION_NOTIONAL]: notionalGroup,
  [LiveGridColumnId.NEGOTIATION_RATE]: rateGroup,
  [LiveGridColumnId.NEGOTIATION_HAIRCUT]: haircutGroup,
  [LiveGridColumnId.NEGOTIATION_START_DATE]: startDateGroup,
  [LiveGridColumnId.NEGOTIATION_END_DATE]: endDateGroup,
  [LiveGridColumnId.NEGOTIATION_START_CONSIDERATION]: startConsiderationGroup
}
